export default __webpack_public_path__ + "media/color/sngls-2a285f04.svg";